// angular
import { NgClass } from '@angular/common';
import { Component, input } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'pwj-project-card-skeleton',
  standalone: true,
  imports: [NgxSkeletonLoaderModule, NgClass],
  templateUrl: './project-card-skeleton.component.html',
  styleUrls: [
    '../../product-card/product-card-skeleton/product-card-skeleton.component.scss',
    './project-card-skeleton.component.scss',
  ],
  host: {
    class: 'product-card-skeleton-host--compact',
    '[class.product-card-skeleton-host--list]': 'wrapInListItem()',
  },
})
export class ProjectCardSkeletonComponent {
  count = input<number>(1);
  wrapInListItem = input<boolean>(false);
  containerClasses = input<string>('');

  public counter(i: number) {
    return new Array(i);
  }
}
